var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStoreInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA9\x94\xEC\x8B\x9C\xEC\xA7\x80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M9.99935 3.33333V2.83333H9.99932L9.99935 3.33333ZM16.6663 9.99935H17.1663V9.99932L16.6663 9.99935ZM15.5511 13.6888L15.1349 13.4117C15.0459 13.5454 15.0265 13.7138 15.0829 13.8643L15.5511 13.6888ZM16.6673 16.6663L16.4918 17.1345C16.6753 17.2033 16.8822 17.1585 17.0209 17.0199C17.1595 16.8813 17.2043 16.6744 17.1355 16.4908L16.6673 16.6663ZM13.6908 15.5501L13.8663 15.082C13.7158 15.0255 13.5473 15.0449 13.4135 15.134L13.6908 15.5501ZM9.99935 16.6663L9.99932 17.1663H9.99935V16.6663ZM3.33333 9.99935L2.83333 9.99932V9.99935H3.33333ZM9.99935 3.33333V3.83333C13.4049 3.83333 16.1662 6.594 16.1663 9.99937L16.6663 9.99935L17.1663 9.99932C17.1661 6.04156 13.957 2.83333 9.99935 2.83333V3.33333ZM16.6663 9.99935H16.1663C16.1663 11.2618 15.7858 12.4342 15.1349 13.4117L15.5511 13.6888L15.9673 13.9659C16.7235 12.8302 17.1663 11.466 17.1663 9.99935H16.6663ZM15.5511 13.6888L15.0829 13.8643L16.1991 16.8419L16.6673 16.6663L17.1355 16.4908L16.0193 13.5133L15.5511 13.6888ZM16.6673 16.6663L16.8429 16.1982L13.8663 15.082L13.6908 15.5501L13.5152 16.0183L16.4918 17.1345L16.6673 16.6663ZM13.6908 15.5501L13.4135 15.134C12.4358 15.7855 11.2626 16.1663 9.99935 16.1663V16.6663V17.1663C11.4668 17.1663 12.8318 16.7233 13.968 15.9662L13.6908 15.5501ZM9.99935 16.6663L9.99937 16.1663C6.594 16.1662 3.83333 13.4049 3.83333 9.99935H3.33333H2.83333C2.83333 13.957 6.04156 17.1661 9.99932 17.1663L9.99935 16.6663ZM3.33333 9.99935L3.83333 9.99937C3.8335 6.59404 6.59404 3.8335 9.99937 3.83333L9.99935 3.33333L9.99932 2.83333C6.04174 2.83353 2.83353 6.04174 2.83333 9.99932L3.33333 9.99935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 6.66667,
    cy: 10,
    r: 0.833333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 10,
    cy: 10,
    r: 0.833333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 13.3333,
    cy: 10,
    r: 0.833333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStoreInquiry);
export default __webpack_public_path__ + "static/media/ic_store_inquiry.6ab73530c1e52a49f7bdca8b6f7b4f1d.svg";
export { ForwardRef as ReactComponent };